(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    /* Two-panel sidebar navigation */
  /* Track the active filter tab so we can restore it after section re-render */
  var activeFilterTab = null;

  function restoreActiveTab(drawer) {
    if (!activeFilterTab || !drawer) return;

    var targetItem = drawer.querySelector('.fd-sidebar__item[data-fd-target="' + activeFilterTab + '"]');
    if (!targetItem) return;

    drawer.querySelectorAll('.fd-sidebar__item').forEach(function (item) {
      item.classList.remove('fd-sidebar__item--active');
    });
    targetItem.classList.add('fd-sidebar__item--active');

    drawer.querySelectorAll('.fd-panel').forEach(function (panel) {
      if (panel.getAttribute('data-fd-panel') === activeFilterTab) {
        panel.classList.add('fd-panel--visible');
        panel.querySelectorAll('details').forEach(function (d) { d.setAttribute('open', ''); });
      } else {
        panel.classList.remove('fd-panel--visible');
      }
    });
  }

  /* Restore active tab after section re-render (morph) */
  var isRestoring = false;
  var observer = new MutationObserver(function () {
    if (!activeFilterTab || isRestoring) return;
    var drawer = document.querySelector('.facets--drawer');
    if (!drawer) return;

    /* Check if the morph reset the active tab (first tab is active but shouldn't be) */
    var currentActive = drawer.querySelector('.fd-sidebar__item--active');
    var currentTarget = currentActive ? currentActive.getAttribute('data-fd-target') : null;
    if (currentTarget !== activeFilterTab) {
      isRestoring = true;
      restoreActiveTab(drawer);
      isRestoring = false;
    }
  });

  /* Observe the filters drawer for child/subtree changes caused by morph */
  function startObserving() {
    var drawerDialog = document.querySelector('#filters-drawer');
    if (drawerDialog) {
      observer.observe(drawerDialog, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }
  startObserving();

  document.addEventListener('click', function (e) {
    var sidebarItem = e.target.closest('.fd-sidebar__item');
    if (!sidebarItem) return;

    var target = sidebarItem.getAttribute('data-fd-target');
    if (!target) return;

    var drawer = sidebarItem.closest('.facets--drawer');
    if (!drawer) return;

    /* Remember which tab the user selected */
    activeFilterTab = target;

    /* Update sidebar active state */
    drawer.querySelectorAll('.fd-sidebar__item').forEach(function (item) {
      item.classList.remove('fd-sidebar__item--active');
    });
    sidebarItem.classList.add('fd-sidebar__item--active');

    /* Show matching panel, hide others */
    drawer.querySelectorAll('.fd-panel').forEach(function (panel) {
      if (panel.getAttribute('data-fd-panel') === target) {
        panel.classList.add('fd-panel--visible');
        /* Force details open */
        panel.querySelectorAll('details').forEach(function (d) { d.setAttribute('open', ''); });
      } else {
        panel.classList.remove('fd-panel--visible');
      }
    });
  });

  /* Drag-to-dismiss bottom sheet on mobile */
  (function () {
    var DISMISS_THRESHOLD = 100;
    var startY = 0;
    var currentY = 0;
    var dragging = false;
    var dialog = null;

    function getDialog(handle) {
      return handle.closest('dialog');
    }

    function closeDrawer(dialogEl) {
      var component = dialogEl.closest('dialog-component');
      if (component && typeof component.closeDialog === 'function') {
        component.closeDialog();
      }
    }

    function onPointerDown(e) {
      if (window.innerWidth >= 750) return;
      var handle = e.target.closest('[data-fd-drag-handle]');
      if (!handle) return;

      dialog = getDialog(handle);
      if (!dialog) return;

      dragging = true;
      startY = e.clientY || (e.touches && e.touches[0].clientY) || 0;
      currentY = startY;
      dialog.style.transition = 'none';
      handle.setPointerCapture(e.pointerId);
    }

    function onPointerMove(e) {
      if (!dragging || !dialog) return;
      currentY = e.clientY || (e.touches && e.touches[0].clientY) || 0;
      var deltaY = currentY - startY;

      /* Only allow dragging downward */
      if (deltaY < 0) deltaY = 0;

      dialog.style.transform = 'translateY(' + deltaY + 'px)';
    }

    function onPointerUp() {
      if (!dragging || !dialog) return;
      dragging = false;

      var deltaY = currentY - startY;
      dialog.style.transition = '';
      dialog.style.transform = '';

      if (deltaY > DISMISS_THRESHOLD) {
        closeDrawer(dialog);
      }

      dialog = null;
    }

    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerUp);
    document.addEventListener('pointercancel', onPointerUp);
  })();

  /* Delivery Method: sync "Fast Delivery" toggle with hidden value checkboxes */
  document.addEventListener('change', function (e) {
    var toggle = e.target.closest('[data-delivery-fast-toggle]');
    if (!toggle) return;

    var li = toggle.closest('li');
    if (!li) return;

    var hiddenInputs = li.querySelectorAll('[data-delivery-fast-value]');
    var isChecked = toggle.checked;

    hiddenInputs.forEach(function (input) {
      input.checked = isChecked;
    });

    /* Trigger the facet form update */
    var facetInputsComponent = toggle.closest('facet-inputs-component');
    if (facetInputsComponent) {
      var evt = new Event('change', { bubbles: true });
      hiddenInputs[0].dispatchEvent(evt);
    }
  });

  /* Drop changes that were never applied, so the drawer always opens showing only what is applied */
  function resetUnappliedChanges(drawer) {
    var currentParams = new URLSearchParams(window.location.search);

    drawer.querySelectorAll('.fd-panel input[type="checkbox"][name]').forEach(function (cb) {
      cb.checked = currentParams.getAll(cb.name).indexOf(cb.value) !== -1;
    });

    /* Price: the sliders and the two boxes go back to what the server rendered for the applied
       state; snippets/price-filter.liquid redraws the slider fill on price-facet:sync */
    drawer.querySelectorAll('price-facet-component').forEach(function (facet) {
      facet.querySelectorAll('input').forEach(function (input) {
        input.value = input.defaultValue;
      });
      facet.dispatchEvent(new Event('price-facet:sync'));
    });
  }

  /* However the drawer is opened (Filters pill, a filter pill, "more" in the grid), start clean.
     dialog:open does not bubble, so it is caught in the capture phase. */
  document.addEventListener('dialog:open', function (e) {
    if (e.target instanceof Element && e.target.id === 'filters-drawer') resetUnappliedChanges(e.target);
  }, true);

  /* Topline filter pill (collection and search): open the drawer on that filter's panel */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.topline-filters__pill--filter');
    if (!pill || pill.id === 'topline-filter-sort') return;

    var label = pill.getAttribute('data-filter-label');
    if (!label) return;

    var drawer = document.getElementById('filters-drawer');
    if (!drawer) return;

    /* Hide the panels container instantly to prevent the flash of the
       previously active panel while we wait for the dialog to open. */
    var panels = drawer.querySelector('.fd-panels');
    if (panels) panels.style.opacity = '0';

    /* Click the sidebar item AFTER the dialog finishes opening.
       Clicking the actual button runs the sidebar handler above, which
       records the tab so it is restored after a section re-render. */
    setTimeout(function () {
      var sidebarItems = drawer.querySelectorAll('.fd-sidebar__item');
      for (var i = 0; i < sidebarItems.length; i++) {
        var sidebarLabel = sidebarItems[i].querySelector('.fd-sidebar__label');
        if (sidebarLabel && sidebarLabel.textContent.trim().toLowerCase() === label.toLowerCase()) {
          sidebarItems[i].click();
          sidebarItems[i].scrollIntoView({ block: 'nearest' });
          break;
        }
      }
      /* Reveal panels after switch */
      if (panels) panels.style.opacity = '';
    }, 150);
  }, true);

  /* "Apply Filters": apply the drawer's pending changes (see manual-apply in facets.js) */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-apply-filters]')) return;

    var fc = document.querySelector('#filters-drawer facets-form-component');
    if (!fc || typeof fc.applyPendingFilters !== 'function' || !fc.applyPendingFilters()) return;

    /* Close the dialog after applying — prevents morphed state from being
       "locked in" by the framework's morph observer. */
    var dialog = document.querySelector('#filters-drawer dialog');
    if (dialog && dialog.open) {
      setTimeout(function () { dialog.close(); }, 50);
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
